import { Button, HoverIcon } from '@checkatrade/web-ui';
import {
  HeartFill,
  HeartOutline,
} from '@cat-home-experts/mortar-iconography-web';
import { colors } from '@checkatrade/web-ui/themes';
import { useAnalytics } from 'lib/sdks/analytics/hooks';
import { useIsAuthenticated } from 'lib/auth/auth.hooks';

export const SaveTradesButton = () => {
  const { trackAndNavigate } = useAnalytics();
  const isAuthenticated = useIsAuthenticated();

  return (
    <Button
      className="p-0"
      variant="unstyled"
      aria-label="View your saved trades"
      onClick={() => {
        trackAndNavigate(
          'global.navigate_to_saved_trades',
          '/consumer/saved-trades',
          {
            is_logged_in: isAuthenticated,
          },
        );
      }}
    >
      <HoverIcon
        defaultIcon={HeartOutline}
        hoverIcon={HeartFill}
        size={40}
        color={colors.primary.DEFAULT}
      />
    </Button>
  );
};
